import jQuery from 'jquery'
import Chart from 'chart.js';
global.jQuery=jQuery
global.$=jQuery
global.Chart=Chart
require('jquery.easing')
// require('./assets/vendor/vali-admin/docs/js/plugins/bootstrap-datepicker.min.js')

// require('./assets/vendor/vali-admin/docs/js/plugins/jquery.dataTables.min.js')
// require('./assets/vendor/vali-admin/docs/js/plugins/dataTables.bootstrap.min.js')

import 'magnific-popup'

import Vue from 'vue'
import './registerServiceWorker'
import 'bootstrap'

// Vue.component('BounceLoader', require('vue-spinner/src/BounceLoader.vue'));

/////////////////////
// Composition API //
/////////////////////
import VueCompositionAPI from '@vue/composition-api';
Vue.use(VueCompositionAPI);
/////////////////////
// Composition API //
/////////////////////


///////////////
// Event Bus //
///////////////
export const eventBus = new Vue();
///////////////
// Event Bus //
///////////////

////////////////
// Vue Editor //
////////////////
require('@/src/plugins/vue-editor')
////////////////
// Vue Editor //
////////////////


//////////////////////
// Upload component //
//////////////////////
require('@/src/plugins/vue-upload-component')
//////////////////////
// Upload component //
//////////////////////

//////////////////
// Vue Dropzone //
//////////////////
require('@/src/plugins/vue2-dropzone')
//////////////////
// Vue Dropzone //
//////////////////


// Vue Good Table
require('@/src/plugins/vue-good-table')

// Vue Tooltip
require('@/src/plugins/vue-tooltip')

// Vue Spinner
require('@/src/plugins/vue-spinner.js')

// Vue Signature Pad
require('@/src/plugins/vue-signature-pad.js')

/////////////////////
// Content Loading //
/////////////////////
// Docs: https://www.npmjs.com/package/vue-content-loader
import { ContentLoader } from 'vue-content-loader'
Vue.component(ContentLoader)
/////////////////////
// Content Loading //
/////////////////////

/////////////////////
// Truncate String //
/////////////////////
Vue.filter('truncate', (value, max) => {
	if(!value) return ''
	max=max||20
	if(value.length>max) {
		return value.trim().substr(0, max)+'...'
	}
	return value
});
/////////////////////
// Truncate String //
/////////////////////

///////////////////
// Number Filter //
///////////////////
import numeral from 'numeral';
import numFormat from 'vue-filter-number-format';
Vue.filter('numFormat', numFormat(numeral));
///////////////////
// Number Filter //
///////////////////

/////////////////
// Form Wizard //
/////////////////
import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
Vue.use(VueFormWizard)
/////////////////
// Form Wizard //
/////////////////


////////////////
// Vue Select //
////////////////
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
Vue.component('v-select', vSelect)
////////////////
// Vue Select //
////////////////


//////////////////
// Momemnts Ago //
//////////////////
import VueMomentsAgo from 'vue-moments-ago'
Vue.component('vue-moments-ago', VueMomentsAgo)
//////////////////
// Momemnts Ago //
//////////////////


//////////////
// Vuetable //
//////////////
// Docs: https://www.vuetable.com/
import Vuetable from 'vuetable-2'
Vue.component('vuetable', Vuetable)
//////////////
// Vuetable //
//////////////

////////////////
// Datepicker //
////////////////
// Docs:: https://www.npmjs.com/package/vue2-datepicker
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
Vue.use(DatePicker)
////////////////
// Datepicker //
////////////////


/////////////////
// SweetAlert2 //
/////////////////
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);
/////////////////
// SweetAlert2 //
/////////////////


//////////////////
// Vee Validate //
//////////////////
require('@/src/plugins/vee-validate')
//////////////////
// Vee Validate //
//////////////////

////////////////
// Vue Moment //
////////////////
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
Vue.use(VueMoment, {
    moment,
})
////////////////
// Vue Moment //
////////////////


//////////////
// Resource //
//////////////
import VueResource from 'vue-resource'
Vue.use(VueResource)
//////////////
// Resource //
//////////////

//////////////
// Fragment //
//////////////
import Fragment from 'vue-fragment'
Vue.use(Fragment.Plugin)
//////////////
// Fragment //
//////////////


///////////
// Store //
///////////
import Store from './store'
import Vuex from 'vuex';
Vue.use(Vuex);
export const store=new Vuex.Store(Store);
///////////
// Store //
///////////


//////////////
// Validate //
//////////////
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)
//////////////
// Validate //
//////////////




////////////
// Logout //
////////////
eventBus.$on('logout', () => {
	Vue.swal({
		text: 'Signing out. . .',
		allowOutsideClick: false
	})
	Vue.swal.showLoading()
	store.dispatch('auth/logout')
		.then(response => {
			window.location.href='/'
		})
})
////////////
// Logout //
////////////
Vue.config.productionTip = false


import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
export const i18n = new VueI18n({
  locale: 'en', // set locale
  messages: require('./language').default, // set locale messages
})



